import { Link } from 'react-router-dom';
import { Aperture } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-surface-0 px-4 text-center text-fg">
      <Aperture size={32} className="text-fg-muted" aria-hidden="true" />
      <h1 className="font-display font-mono text-6xl font-semibold tabular-nums tracking-tight text-fg">404</h1>
      <p className="max-w-xs text-sm text-fg-secondary">Stran, ki jo iščete, ne obstaja ali je bila premaknjena.</p>
      <Link to="/competitions">
        <Button variant="secondary" className="mt-2">
          Nazaj na tekmovanja
        </Button>
      </Link>
    </div>
  );
}
